import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';

export default function addTagToCurrentApp() {
	/*
	 * Allows to get the current tag with `app.current()`
	 */
	extend(IndexPage.prototype, 'oninit', function () {
		const currentTag = this.currentTag();

		app.current.set('tag', currentTag);
	});
}
